import styled from 'styled-components'
import { faLightbulb } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { attributionMarginLeftPx } from '~/components/map/map'
import type { Layer } from '~/packages/general/variable/spaceTime.types'
import type { ReportWithLayer } from '~/packages/sentinel/reports'
import RightButtons from '~/packages/sentinel/rightButtons.component'
import type { RightButtonsTopBoxProps } from '~/packages/sentinel/rightButtonsTopBox.component'
import ViewSelect from '~/packages/sentinel/viewSelect.component'

const WrapperBottomButtons = styled.div`
  position: absolute;
  top: 0;
  right: 0.6rem;
  bottom: ${attributionMarginLeftPx}px;
  left: 0.6rem;
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 0.3rem;
  padding-bottom: 0.3rem;
  pointer-events: none;

  > * {
    pointer-events: all;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    flex-direction: column;
    align-items: start;
    justify-content: end;
    bottom: 4px;
  }
`

const ReopenInsightsWrapper = styled.aside`
  position: absolute;
  top: 0.6rem;
  right: calc(0.6rem + 40px + 5px);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  box-shadow: ${({ theme }) => theme.shadow(1)};
  background-color: white;
  cursor: pointer;

  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background-color: ${({ theme }) => theme.backdropBackground};
    -webkit-backdrop-filter: ${({ theme }) => theme.backdropFilter};
    backdrop-filter: ${({ theme }) => theme.backdropFilter};
  }
`

interface ViewSelectProps {
  baseLayers: Layer[]
  onChangeReport: (report: ReportWithLayer | null) => void
  stateId: number | null
  stateName: string | null
  subtitle?: string | null
}

interface BaseControlsProps extends RightButtonsTopBoxProps, ViewSelectProps {
  children: React.ReactNode
  isDisabled?: boolean
  isInsightsModalOpen: boolean
  onOpenInsightsModal: () => void
  isReadyForSentinelUI: boolean
}

export const BaseControls = ({
  onChangeMapType,
  mapType,
  onChangeMap3DOption,
  map3DOption,
  layers,
  variables,
  setBaseLayers,
  styles,
  baseLayers,
  onChangeReport,
  stateId,
  stateName,
  subtitle,
  children,
  isDisabled = false,
  isInsightsModalOpen,
  onOpenInsightsModal,
  isReadyForSentinelUI,
}: BaseControlsProps) => {
  return (
    <>
      {!isInsightsModalOpen && isReadyForSentinelUI ? (
        <RightButtons
          onChangeMapType={onChangeMapType}
          mapType={mapType}
          onChangeMap3DOption={onChangeMap3DOption}
          map3DOption={map3DOption}
          layers={layers}
          baseLayers={baseLayers}
          variables={variables}
          setBaseLayers={setBaseLayers}
          styles={styles}
        />
      ) : null}

      {!isInsightsModalOpen && isReadyForSentinelUI ? (
        <>
          <ReopenInsightsWrapper title='Abrir insights' onClick={onOpenInsightsModal}>
            <FontAwesomeIcon icon={faLightbulb} size='lg' />
          </ReopenInsightsWrapper>
        </>
      ) : null}

      <ViewSelect
        variables={variables}
        layers={layers}
        baseLayers={baseLayers}
        setBaseLayers={setBaseLayers}
        onChangeReport={onChangeReport}
        stateId={stateId}
        stateName={stateName}
        subtitle={subtitle}
        isDisabled={isDisabled}
      />

      <WrapperBottomButtons>{children}</WrapperBottomButtons>
    </>
  )
}
